import React from 'react';
import './styles.scss';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AddAisle from './aisle';
/* eslint-disable */

interface Props {
  data: { name: string, items: { level: string, count: number, id: number }[] };
  warehouseId: number | undefined;
  refetch: () => void;
  aisleName: string;
  searchValue: string;
}

function RenderTableWarehouse(props: Props) {
  const {
    data, warehouseId, refetch, aisleName, searchValue,
  } = props;
  return (
    <div className="table-container h-100">
      <div className="d-flex align-items-start justify-content-between mb-4" style={{ marginLeft: '30px', marginRight: '30px' }}>
        <span className="fz-18 fw-bold">{data.name}</span>
        <div>
          <AddAisle
            warehouseId={warehouseId}
            isUpdate
            refetch={refetch}
            aisleName={data.name}
          />
        </div>
      </div>
      <Table responsive borderless>
        <tbody>
          {data.items.map((aisle, i) => (
            <tr className={i % 2 !== 0 ? 'tbody-content' : ''} key={aisle.id}>
              <td className="px-0">
                <Link
                  to={`/warehouse/aisle/${warehouseId}/${aisle.id}/${aisleName}/${aisle.level}${!searchValue ? '' : '/' + searchValue}`}
                  className="fz-14 my-1 d-flex justify-content-between text-decoration-none text-black"
                  style={{ marginLeft: '30px', marginRight: '30px' }}
                >
                  <div>{`Level ${aisle.level}`}</div>
                  <div>
                    {!searchValue ? `Products: ${aisle.count}` : searchValue}
                  </div>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default RenderTableWarehouse;
